<template>
  <div :class="classes">
    <pt-page-title title="新闻分类">
        <el-button slot="before-left" type="primary" @click="creatNewsClassify">新建新闻分类</el-button>
    </pt-page-title>
    <pt-classify-table :tableLabels="tableLabels">
        <el-table-column label="操作">
            <template slot-scope="scope">
                 <i class="iconfont icon-bianji"  @click="editClassify(scope.row)"></i>
            </template>
        </el-table-column>
    </pt-classify-table>
  </div>
</template>

<script>
// 组件class前缀
import { classifyTableLabel } from '../news-option'
import ptClassifyTable from './pt-classify-table/withData'
const label =
{
  'RANKING': '按推荐值排序',
  'CREATED_DATE_ASC': '按创建时间升序排列',
  'CREATED_DATE_DESC': '按创建时间降序排列'
}
const prefixCls = 'pt-news-classify'

export default {
  name: 'pt-news-classify',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: { ptClassifyTable },
  data () {
    return {
      tableLabels: classifyTableLabel
    }
  },
  methods: {
    getlabel (item) {
      return label[item]
    },
    editClassify (val) {
      this.$router.push('/news-manage/news-classify-form/' + val.id + '/' + true)
    },
    creatNewsClassify () {
      this.$router.push('/news-manage/news-classify-form/0/false')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
